"use client";

import {
  PageSubNav,
  type PageSubNavLink,
} from "@/components/layout/page-sub-nav";
import { useHeaderScroll } from "@/components/layout/header-scroll-context";

interface CommunityPageSubNavProps {
  backHref: string;
  links: readonly PageSubNavLink[];
}

export function CommunityPageSubNav({
  backHref,
  links,
}: CommunityPageSubNavProps) {
  const { globalHidden } = useHeaderScroll();

  return (
    <PageSubNav
      title="COMMUNITY"
      titleHref="/community"
      backHref={backHref}
      links={links}
      linkClassName="max-w-[140px] truncate sm:max-w-[220px]"
      className={`sticky z-40 border-b border-line/70 bg-panel/95 backdrop-blur-md transition-[top] duration-300 ease-out ${
        globalHidden ? "top-0" : "top-16 md:top-20"
      }`}
    />
  );
}
